import { Price } from '@/api/models/model_product_detail'
import { PriceTierV2 } from './PlansPage'
import { transformTiersToV2 } from '@/utils/utility_functions'

export const extractPlan = (prices: Price[], billingPeriod: string) => {
    const price = prices.find((price) => price.billing_period === billingPeriod)

    let price_data: PriceTierV2[] | number = 0

    if (price) {
        if (price?.tier_type === 'VOLUME') {
            price_data = transformTiersToV2(price.price_tiers || [])
        } else {
            price_data = billingPeriod.toUpperCase() === 'MONTHLY' ? price.monthly_price ?? 0 : price.annual_price ?? 0
        }
    }

    const result = {
        tier_type:
            price?.tier_type === 'VOLUME'
                ? 'Tiered'
                : price?.tier_type === 'FLAT' && price?.billing_model === 'FLAT_FEE'
                ? 'Flat fee'
                : 'Flat rate',
        price_id: price?.id || undefined,
        price: price_data ?? 0,
    }

    return result
}

export const extractPlanData = (prices: Price[], billingPeriod: string) => {
    const price = prices.find((price) => price.billing_period === billingPeriod)

    let price_data: PriceTierV2[] | number = 0

    if (price) {
        if (price?.tier_type === 'VOLUME') {
            price_data = transformTiersToV2(price.price_tiers || [])
        } else {
            price_data = billingPeriod.toUpperCase() === 'MONTHLY' ? price.monthly_price ?? 0 : price.annual_price ?? 0
        }
    }

    const result = {
        tier_type: price?.tier_type === 'VOLUME' ? 'Tiered' : 'Flat fee',
        price_id: price?.id || undefined,
        price: price_data ?? 0,
    }

    return result
}
